import { render, staticRenderFns } from "./CollectionSpecialLabelPicker.vue?vue&type=template&id=3eb56465"
import script from "./CollectionSpecialLabelPicker.vue?vue&type=script&lang=js"
export * from "./CollectionSpecialLabelPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports